export function useMetronic () {
    onMounted(() => {
        KTComponents.init()
        KTThemeMode.init()
    })
}
